/* KartComms — Getting Started: FAQ accordion (one open at a time) + quick-nav scrollspy. Vanilla, no deps. */
(function () {
  'use strict';

  function initFaq(root) {
    var faq = root.querySelector('[data-faq]');
    if (!faq) return;
    var btns = Array.prototype.slice.call(faq.querySelectorAll('.kcg-q__btn'));

    function setOpen(btn, open) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', String(open));
      if (panel) panel.hidden = !open;
    }

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btns.forEach(function (b) { if (b !== btn) setOpen(b, false); });
        setOpen(btn, !isOpen);
      });
    });
  }

  function initSpy(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-navcard]'));
    if (!cards.length || !('IntersectionObserver' in window)) return;
    var map = {};
    cards.forEach(function (c) { map[c.getAttribute('data-navcard')] = c; });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && map[e.target.id]) {
          cards.forEach(function (c) { c.classList.remove('is-active'); });
          map[e.target.id].classList.add('is-active');
        }
      });
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });

    Object.keys(map).forEach(function (id) {
      var sec = document.getElementById(id);
      if (sec) io.observe(sec);
    });
  }

  function init() {
    var root = document.querySelector('.kcg');
    if (!root) return;
    initFaq(root);
    initSpy(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
